document.querySelectorAll('.pdp-style .accordion-box details').forEach((details, index) => {
  const summary = details.querySelector('summary');
  
  // 1. Force the very first accordion (index 0) to be open on page load
  if (index === 0) {
    details.open = true;
  }

  // 2. Initialize accessibility and classes based on current HTML state
  if (summary) {
    summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
  }
  if (details.open) {
    details.classList.add('open');
  }

  // 3. Listen to the native toggle event (handles user click AND native name-attribute closures)
  details.addEventListener('toggle', () => {
    const isOpen = details.open;

    // Toggle the 'open' class on the details container
    details.classList.toggle('open', isOpen);

    // Update accessibility state on the focusable summary element
    if (summary) {
      summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }
  });
});
